"use strict";

var _interopRequireDefault = require("/app/node_modules/@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.concat.js");

var _classCallCheck2 = _interopRequireDefault(require("/app/node_modules/@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("/app/node_modules/@babel/runtime/helpers/esm/createClass"));

/**
 * Clase que representa los filtros de la consulta del log de asignaciones
 */
var FiltroAsignaciones = /*#__PURE__*/function () {
  function FiltroAsignaciones(profesion, agrupacion, fuero, zona, fechaDesde, fechaHasta) {
    (0, _classCallCheck2.default)(this, FiltroAsignaciones);
    this.profesion = profesion ? profesion : null;
    this.agrupacion = agrupacion ? agrupacion : null;
    this.fuero = fuero ? fuero : null;
    this.zona = zona ? zona : null;
    this.fechaDesde = fechaDesde ? fechaDesde : null;
    this.fechaHasta = fechaHasta ? fechaHasta : null;
  }

  (0, _createClass2.default)(FiltroAsignaciones, [{
    key: "toQuerystring",
    value: function toQuerystring() {
      var query = "&query=zona:".concat(this.zona.id, ",prof:").concat(this.profesion.id, ",date>").concat(this.fechaDesde.replaceAll('-', ''), ",date<").concat(this.fechaHasta.replaceAll('-', ''), "&sort=creacionFecha,desc");
      return query;
    }
  }, {
    key: "clone",
    value: function clone(_ref) {
      var profesion = _ref.profesion,
          agrupacion = _ref.agrupacion,
          fuero = _ref.fuero,
          zona = _ref.zona,
          fechaDesde = _ref.fechaDesde,
          fechaHasta = _ref.fechaHasta;
      this.profesion = profesion;
      this.agrupacion = agrupacion;
      this.fuero = fuero;
      this.zona = zona;
      this.fechaDesde = fechaDesde;
      this.fechaHasta = fechaHasta;
    }
  }]);
  return FiltroAsignaciones;
}();

exports.default = FiltroAsignaciones;